<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="detail">
              <HeaderBar title="会费标准"></HeaderBar>
              <div class="detail__card">
                <div class="detail__card__title">会费标准</div>
                <div class="ql-editor" style="width: 100%;">
                  <p style="text-indent: 2em; margin-top: 16px;">为规范本会会费收取、使用和管理，保证本会工作正常开展，根据国家民政部、财政部《关于调整社会团体会费政策等有关问题的通知》要求，结合我会实际状况，特制定本会会员缴纳会费标准和管理办法。</p>
                  <h3 style="margin-top: 24px;">一、会费收取标准</h3>
                  <h4 style="margin-top: 16px;">（一）单位会员</h4>
                  <p style="text-indent: 2em; margin-top: 12px;">1. 会长单位会费 <strong>40000 元</strong>；</p>
                  <p style="text-indent: 2em; margin-top: 12px;">2. 副会长单位会费 <strong>30000 元</strong>；</p>
                  <p style="text-indent: 2em; margin-top: 12px;">3. 理事单位会费 <strong>10000 元</strong>；</p>
                  <p style="text-indent: 2em; margin-top: 12px;">4. 会员单位会费 <strong>5000 元</strong>；</p>
                  <h4 style="margin-top: 16px;">（二）个人会员</h4>
                  <p style="text-indent: 2em; margin-top: 12px;">个人会员无需缴纳会费；</p>
                  <h3 style="margin-top: 24px;">二、会费缴纳时间和方式</h3>
                  <p style="text-indent: 2em; margin-top: 16px;">会费是本会开展各项活动的主要经费来源，各会员单位有义务交纳会费。会员按年度缴纳会费。每年7月1日前一次性缴足当年会费；每年7月1日后入会的，按当年会费的一半金额缴纳。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">缴纳方式为支票、现金或汇入本会帐户。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">户&emsp;&emsp;名：辽宁省政府采购协会</p>
                  <p style="text-indent: 2em; margin-top: 12px;">开户银行：盛京银行沈阳市泰山支行</p>
                  <p style="text-indent: 2em; margin-top: 12px;">银行账号：0338210102000001572</p>
                  <h3 style="margin-top: 24px;">三、会费开支范围</h3>
                  <p style="text-indent: 2em; margin-top: 16px;">（一）本会章程规定的业务范围和事业的发展；</p>
                  <p style="text-indent: 2em; margin-top: 12px;">（二）必要的行政办公和人员薪酬支出；</p>
                  <p style="text-indent: 2em; margin-top: 12px;">（三）其他由理事会决定的事项。</p>
                  <h3 style="margin-top: 24px;">四、会费管理</h3>
                  <p style="text-indent: 2em; margin-top: 16px;">1. 会费由秘书处负责收取及管理，并开具《社会团体会费统一收据》。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">2. 本会日常经费开支由秘书长审批。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">3. 协会财务账目由专职会计负责，严格执行《民间非营利组织会计制度》，接受会员大会、理事会和会员的质询和监督。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">4. 财务收支情况由秘书处定期向理事会或会员大会报告，每年提交审计部门审计。</p>
                  <p style="text-indent: 2em; margin-top: 12px;">5. 对于无故连续2年不缴纳会费的会员，视为自动退会。</p>
                  <p style="text-align: right; margin-top: 40px;">本办法经2024年12月30日辽宁省政府采购协会第四届会员大会表决通过后生效。</p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  name: 'MemberFeeStandard',
  components: { HeaderBar },
};
</script>

<style lang="scss" scoped>
.detail {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  padding: 10px 10px 0px 10px;
  margin-bottom: 20px;
  &__card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #dcdcdc;
    border-right: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
    &__title {
      background-color: white;
      width: 100%;
      line-height: 100px;
      color: black;
      font-size: 25px;
      font-weight: bold;
      align-self: center;
      text-align: center;
    }
  }
}
.content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}
</style>